
define('jsx!components/shared/loading-indicator',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	],
	function($,_,Backbone,React) {
		return React.createClass({
			render: function() {
				var style = {}
				if(this.props && this.props.color) {
					style.background = this.props.color;
				}
				return (
					React.createElement("div", {className: "sk-flow sk-center"}, 
				        React.createElement("div", {key: "bounce1", className: "sk-flow-dot", style: style}), 
				        React.createElement("div", {key: "bounce2", className: "sk-flow-dot", style: style}), 
				        React.createElement("div", {key: "bounce3", className: "sk-flow-dot", style: style})
					)
				)
			}
		});
	}
);
